import { ToolPolicy, ToolWeight } from './types.js';
export const resolveToolPolicy = (tool, tenantOverride) => {
    const policy = tenantOverride ?? tool.defaultPolicy;
    // Only heavy tools create proposals that require caseworker approval.
    // Terminal tools finish the run immediately and may create a notice.
    if (policy === ToolPolicy.AutoRun && tool.weight === ToolWeight.Heavy) {
        return ToolPolicy.RequireApproval;
    }
    return policy;
};
export const isToolEnabled = (tool, tenantOverride) => resolveToolPolicy(tool, tenantOverride) !== ToolPolicy.Disabled;
//# sourceMappingURL=policy.js.map